import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagTemplatesElementsDaoService } from './dao/tag-templates-elements-dao.service';
import { TagTemplatesElementDbTableDefinition } from './dao/tag-templates-elements-dao/tag-templates-element-db-table-definition';
import { TagTemplatesElementsDbDaoService } from './dao/tag-templates-elements-dao/tag-templates-elements-db-dao.service';
import { TagTemplatesElementsService } from './logic/tag-templates-elements.service';
import { TagTemplatesElementsLogicService } from './logic/tag-templates-elements/tag-templates-elements-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: TagTemplatesElementsService, useClass: TagTemplatesElementsLogicService },
    { provide: TagTemplatesElementsDaoService, useClass: TagTemplatesElementsDbDaoService },
    { provide: TagTemplatesElementDbTableDefinition },
  ]
})
export class TagTemplatesElementsModule { }
